/**
 * Route polyline rendering configuration
 */

// Direction icon configuration
export const DIRECTION_ICON_INTERVAL_PX = 60 * 2
export const ICON_RADIUS = 9.5
export const ICON_INNER_RADIUS = 7.5
export const MAX_PATH_ZOOM_FOR_BREADCRUMBS = 14
